<div class="pages-result__card">
	<a class="pages-result__link" :href="url">
		<component :is="contentType" :title="title" :url="url" :highlightResults="highlightResults" :imageUrl="imageUrl" />
		<div class="pages-result__content-col">
			<div class="pages-result__mini-kicker">{{contentTypeDisplay}}</div>
			<span v-html="highlightResults.title.value">{{highlightResults.title.value}}</span>
		</div>
	</a>
</div>
